export default __webpack_public_path__ + "static/media/video-studio-bg.4048b544.jpg";